import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.Alert,
  title: 'Alert',
  category: ComponentCategory.General,
};
